import React, { useEffect, useState } from 'react'
import { HugeiconsIcon } from "@hugeicons/react";
import { NotificationOff01Icon } from "@hugeicons/core-free-icons";
import { Typography } from '../Typography';
import { cn } from "@/lib/utils";

function NoNetworkConnection({ className }) {
    const [hasNetwork, setHasNetwork] = useState(true);
    
    useEffect(() => {
        window.addEventListener('online', () => setHasNetwork(true));
        window.addEventListener('offline', () => setHasNetwork(false));
    }, [])

    return (
        hasNetwork ? null : (
            <div className={cn("fixed inset-0 z-[9999] flex items-center justify-center bg-background", className)}>
                <div className="flex flex-col items-center justify-center pb-2">
                    <HugeiconsIcon icon={NotificationOff01Icon} size={48} />
                </div>
                <div className="text-center">
                    <Typography variant="h2" gutterBottom align='center'>Oops!</Typography>
                    <Typography variant="subtitle1" className='fs-18 text-center'>
                        No internet connection. Please check your internet settings
                    </Typography>
                </div>
            </div>
        )
    )
}

export default NoNetworkConnection